

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class OptionSourceView extends BaseEntity
{   
    public Value: number; 
    public StrValue: string; 
    public Text: string; 
	
}



